module.exports = __webpack_public_path__ + "img/whatsapp-gold.d275cb35.svg";